import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesApplyFiftyPercentDiscount } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SelectedDaysType } from "../ui";

export const useCreateRulesSushiLunch = ({
  setOpenModalCreate,
  days,
  selectedCategoryIds,
}: {
  setOpenModalCreate: (val: boolean) => void;
  days: SelectedDaysType;
  selectedCategoryIds: string[];
}) => {
  const [loading, setLoagding] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Campo requerido"),
      })
    ),
  });

  const handleSubmit = onSubmit(async (data: any) => {
    if (loading) return;

    setLoagding(true);
    await rulesApplyFiftyPercentDiscount
      .create({
        ...data,
        category_ids: selectedCategoryIds.map((id) => Number(id)),
        apply_to_category_id: selectedCategoryIds[0]
          ? Number(selectedCategoryIds[0])
          : data.apply_to_category_id
            ? Number(data.apply_to_category_id)
            : undefined,
        monday: days.monday,
        tuesday: days.tuesday,
        wednesday: days.wednesday,
        thursday: days.thursday,
        friday: days.friday,
        saturday: days.saturday,
        sunday: days.sunday,
      })
      .then((_res: any) => {
        notify.success(`Se ha creado la regla  exitosamente`);
        setOpenModalCreate(false);
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoagding(false);
      });
  });

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
